import SEOHead from '../components/SEOHead';
import { Card, Input, Checkbox, Container, Stack, Body, Muted, H2, H3 } from '../components/ui';

const FEATURES = [
  { key: 'has_options_breakdown', label: 'Option Analysis' },
  { key: 'has_greeks_calculator', label: 'Greeks Calculator' },
  { key: 'has_margin_calculator', label: 'Margin Calculator' },
  { key: 'has_position_sizer',    label: 'Position Sizer' },
  { key: 'is_ad_free',            label: 'Ad-Free Experience' },
];

function ComingSoonBadge() {
  return (
    <span className="text-xs bg-neutral-100 dark:bg-neutral-700 text-neutral-500 dark:text-neutral-400 px-2 py-0.5 rounded-full">
      Coming Soon
    </span>
  );
}

export default function Account() {
  return (
    <>
      <SEOHead
        title="My Account"
        description="Manage your OptionView account, features and settings."
        canonicalPath="/account"
      />
      <Container className="py-10 max-w-2xl mx-auto">
        <H2 className="mb-6">My Account</H2>
        <Stack gap={6}>

          {/* Profile */}
          <Card variant="bordered">
            <Card.Header><H3>Profile</H3></Card.Header>
            <Card.Body>
              <Stack gap={4}>
                <div>
                  <label className="block text-sm font-medium text-neutral-700 dark:text-neutral-300 mb-1">Name</label>
                  <Input value="—" readOnly className="w-full" onChange={() => {}} />
                </div>
                <div>
                  <label className="block text-sm font-medium text-neutral-700 dark:text-neutral-300 mb-1">Email</label>
                  <Input value="—" readOnly className="w-full" onChange={() => {}} />
                </div>
                <Muted>Profile editing coming soon.</Muted>
              </Stack>
            </Card.Body>
          </Card>

          {/* Active Features */}
          <Card variant="bordered">
            <Card.Header><H3>Active Features</H3></Card.Header>
            <Card.Body>
              <Stack gap={3}>
                {FEATURES.map(({ key, label }) => (
                  <Checkbox key={key} label={label} checked disabled onChange={() => {}} />
                ))}
                <Muted>All features are currently available to everyone.</Muted>
              </Stack>
            </Card.Body>
          </Card>

          {/* Billing */}
          <Card variant="bordered">
            <Card.Header>
              <div className="flex items-center gap-2">
                <H3>Billing</H3>
                <ComingSoonBadge />
              </div>
            </Card.Header>
            <Card.Body>
              <Body>Subscription management will be available here.</Body>
            </Card.Body>
          </Card>

          {/* Settings */}
          <Card variant="bordered">
            <Card.Header>
              <div className="flex items-center gap-2">
                <H3>Settings</H3>
                <ComingSoonBadge />
              </div>
            </Card.Header>
            <Card.Body>
              <Body>Account preferences and notification settings will appear here.</Body>
            </Card.Body>
          </Card>

        </Stack>
      </Container>
    </>
  );
}
